package one.healthium.domain.user.models

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class WaterLogModel(
    val value: Float,
    val date: Instant,
)
